import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Nav } from 'reactstrap';

import classnames from 'classnames';
import styles from './index.module.scss';

export class TabHeaderV2 extends Component {
  static propTypes = {
    inverted: PropTypes.bool,
  };

  render() {
    const { className, inverted, fillWithGreen, fillWithPurple, ...other } = this.props;

    const defaultClasses = classnames(className, {
      [styles.inverted]: inverted,
      [styles.tabHeader]: !inverted,
      [styles.fillWithGreen]: fillWithGreen,
      [styles.fillWithPurple]: fillWithPurple,
    });

    return <Nav className={defaultClasses} {...other} tabs />;
  }
}

export default TabHeaderV2;
